import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { SMBShipping } from '@/screens/SMB-Shipping';

export default function ModeOptimizationPage() {
  return (
    <>
      <Head>
        <meta
          name="keywrds"
          content="shipper software, ltl freight, ftl freight"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        title="SMB Shipping | Loadsmart"
        description="Leverage the same tools and operating power as the Fortune 100 to instantly quote and book spot loads and price and award contract business"
        canonical="https://loadsmart.com/smb-shipping/"
        openGraph={{
          url: 'https://loadsmart.com/smb-shipping/',
        }}
      />
      <SMBShipping />
    </>
  );
}
